import React from 'react'

const ProgressBar = ({bgcolor,progress,height,isValueShown}) => {
    const Parentdiv = {
        height: height,
        width: '100%',
        backgroundColor: '#E2E8F0',
        borderRadius: 40,
        margin: 0
      }
      
      const Childdiv = {
        height: '100%',
        width: `${progress}%`,
        backgroundColor: bgcolor,
       borderRadius:40,
        textAlign: 'right'
      }
      
      const progresstext = {
        padding: 10,
        color: 'black',
        fontWeight: 900
      }
        
  return (
    <div style={Parentdiv}>
        <div style={Childdiv}>
        {isValueShown && <span style={progresstext}>{`${progress}%`}</span>}
        </div>
  </div>
  )
}

export default ProgressBar
